import { Checkbox, FormControlLabel } from "@material-ui/core";
import parse from "html-react-parser";
import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { content, set_app_config } from "../../../config/redux/actions/option";
import BasicText from "../../atom/BasicText/BasicText";
import ButtonContained from "../../atom/Button/ButtonContained";
import TempAuth from "../../template/TempAuth";

const CONTENT_KEY = "kebijakan_privasi_registrasi";

const RegisterAgreement = ({ history, content, optionData }) => {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    content(CONTENT_KEY);
  }, []);

  const handleToggleCheck = useCallback(() => {
    setChecked((e) => !e);
  }, []);

  const handleSubmit = useCallback(() => {
    if (checked) {
      history.push("/register");
    }
  }, [checked, history]);

  return (
    <TempAuth page="regisForm" data={{ title: "KEBIJAKAN PRIVASI" }}>
      <div className="d-flex flex-column">
        <div className="overflow-auto mb-2" style={{ maxHeight: "70vh" }}>
          {parse(optionData[CONTENT_KEY])}
        </div>

        <FormControlLabel
          control={
            <Checkbox
              id="s&k"
              checked={checked}
              size="small"
              className="mt-n2"
              onChange={handleToggleCheck}
            />
          }
          label={
            <BasicText className="fs-12 gray-5">
              Saya telah membaca, memahami dan menyetujui seluruh informasi,
              syarat dan ketentuan Kebijakan Privasi PT Syailendra Capital
            </BasicText>
          }
          className="mb-4 pb-1 align-items-start"
          classes={{ label: "gray-5 font-family" }}
          labelPlacement="end"
        />

        <ButtonContained
          text="SETUJU"
          radius={4}
          className="mt-auto"
          disabled={!checked}
          onClick={handleSubmit}
        />
      </div>
    </TempAuth>
  );
};

const mapStateToProps = ({ optionReducer }) => ({
  system: optionReducer.config.system,
  optionData: optionReducer,
});

export default compose(
  connect(mapStateToProps, { set_app_config, content }),
  withRouter
)(RegisterAgreement);
